      <div class="start-btn item-center md-1" (click)="OpenNDID()" id="btnNDID">
        <div class="text-center" style="width: 100%;">
          <img class="mt-4" src="../../assets/images/72ppi/72ppi/Web Portal-วิกฤต-ตัด-04_no_bg.png" id="imgBtn3">
        </div>
        <div class="btn-label">
          <div class="vertical-center centered-content" style="width: 100%;">
            <label style="font-size: 1.1rem;" translate>Verifiaction identity ndid</label>
          </div>
        </div>
      </div> 
      <div class="row centered-content">
        <div class="col-12 col-lg-10">
                <div class="row m-3">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">UID</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control"  id="dpa_contact_id" >
                        </div>
                        </div>
                </div> 
                </div>
            </div>
      </div> 
    <div class="col-12 centered-content">
      <button class="btn btn-default" (click)="CreateTable1()">ค้นหา</button> 
      <button class="btn btn-default m-2 sr-only" style="width: 180px;" id="btnInvestigate" (click)="InvestigateAndAppealStatus()">
        <i class="fas fa-chevron-right bank-card-arrow"></i>
        <label id="lblInvestigate">อุทธรณ์</label>
      </button>
    </div>




// WEBPACK FOOTER //
// ./src/app/testndid/testndid.component.html